import { useTranslationDetector } from "@/hooks/useTranslationDetector";
import { usePriceFormatter } from "@/hooks/usePriceFormatter";

export default function LocationAnalytics({ location }) {
  const t = useTranslationDetector();
  const { formatPrice } = usePriceFormatter();

  return (
    <div className="border-primary-weak bg-background-global grid grid-cols-4 rounded-[10px] border text-lg">
      <div className="max-md:border-primary-weak md:border-primary-weak col-span-4 py-6 max-md:border-b sm:col-span-2 md:border-r md:py-10 lg:col-span-1">
        <div className="flex w-full flex-col items-center justify-center gap-[5px]">
          <div>{t("Car.averageDailyPrice")}</div>
          <div className="font-semibold">
            {formatPrice(location?.Data?.AverageDailyRentalPrice)}
          </div>
        </div>
      </div>
      <div className="max-md:border-primary-weak lg:border-primary-weak col-span-4 py-6 max-md:border-b sm:col-span-2 md:py-10 lg:col-span-1 lg:border-r">
        <div className="flex w-full flex-col items-center justify-center gap-[5px]">
          <div>{t("Car.popularVehicleClass")}</div>
          <div className="font-semibold">
            {t(`Car.${location?.Data?.PopularClass}`)}
          </div>
        </div>
      </div>
      <div className="max-sm:border-primary-weak md:border-primary-weak col-span-4 py-6 max-sm:border-b sm:col-span-2 md:border-r md:py-10 lg:col-span-1">
        <div className="flex w-full flex-col items-center justify-center gap-[5px]">
          <div>{t("Car.popularCompany")}</div>
          <div className="font-semibold">
            {location?.Data?.PopularCompanyName}
          </div>
        </div>
      </div>
      <div className="col-span-4 py-6 sm:col-span-2 md:py-10 lg:col-span-1">
        <div className="flex w-full flex-col items-center justify-center gap-[5px]">
          <div>{t("Car.popularRentalDurations")}</div>
          <div className="font-semibold">
            {`${location?.Data?.TypicalRentalDurationInDays === 1 ? `${location?.Data?.TypicalRentalDurationInDays} ${t("Car.Day")}` : `${location?.Data?.TypicalRentalDurationInDays} ${t("Car.Days")}`}`}
          </div>
        </div>
      </div>
    </div>
  );
}
